import { cn } from "../index";
import { APP_NAME, WEB_DOMAIN } from "@ascra/utils";
import type { PropsWithChildren } from "react";
import { Wordmark } from "../brand";

export function ColoredLayout({ children }: PropsWithChildren) {
  return (
    <>
      <div className="absolute inset-0 isolate overflow-hidden bg-background">
        <div
          className={cn(
            "absolute inset-y-0 left-1/2 w-[1200px] -translate-x-1/2",
            "mask-intersect mask-[linear-gradient(black,transparent_320px),linear-gradient(90deg,transparent,black_5%,black_95%,transparent)]",
          )}
          aria-hidden="true"
        >
        </div>

        {/* Gradient */}
        {[...Array(2)].map((_, idx) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: idx is unique
            key={idx}
            className={cn(
              "absolute top-6 left-1/2 size-[80px] -translate-x-1/2 -translate-y-1/2 scale-x-[1.6]",
              idx === 0 ? "mix-blend-overlay" : "opacity-10",
            )}
            aria-hidden="true"
          >
            {[...Array(idx === 0 ? 2 : 1)].map((_, idx) => (
              <div
                // biome-ignore lint/suspicious/noArrayIndexKey: idx is unique
                key={idx}
                className={cn(
                  "absolute -inset-16 mix-blend-overlay blur-[50px] saturate-[2]",
                  "bg-[conic-gradient(from_90deg,#F00_5deg,#EAB308_63deg,#5CFF80_115deg,#1E00FF_170deg,#855AFC_220deg,#3A8BFD_286deg,#F00_360deg)]",
                )}
              />
            ))}
          </div>
        ))}
      </div>
      <div className="relative flex min-h-screen w-full justify-center">
        <a
          data-testid="logo-link"
          href={WEB_DOMAIN}
          className="absolute top-4 left-1/2 z-10 -translate-x-1/2"
          rel="noopener noreferrer"
        >
          <Wordmark className="h-12" />
          <span className="sr-only">{APP_NAME}</span>
        </a>
        {children}
      </div>
    </>
  );
}
